import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { IntegrationsDataProvider } from '@services/integrations/integrations.data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RandomStringGeneratorProvider } from '@services/helpers/random-string-generator';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'integrate-quick-books-modal',
	template: require('./integrate-quick-books-modal.html')
})
export class IntegrateQuickBooksModal implements OnInit, OnDestroy {
	@Input() accountList;
	button_disabled: boolean;
	isChecked: boolean;
	checkboxId: string;
	chosenAccount: any;
	chosenTaxCodes: any;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private messageService: MessageService,
		private activeModal: NgbActiveModal,
		private integrationsDataService: IntegrationsDataProvider,
		private randomStringGenerator: RandomStringGeneratorProvider
	) {}

	ngOnInit(): void {
		const checkboxIndex = this.randomStringGenerator.getMixedString();
		this.checkboxId = `checkbox-squared-is-checked-${checkboxIndex}`;
		this.setQuickBooksAccounts();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	setQuickBooksAccounts(): void {
		const {
			accountId,
			taxCodeId,
			accounts,
			taxCodes,
			paymentsEnabled
		} = this.accountList;

		this.chosenAccount = accountId
			? accounts.find(account => account.key === accountId)
			: accounts[0];

		this.chosenTaxCodes = taxCodeId
			? taxCodes.find(account => account.key === taxCodeId)
			: taxCodes[0];

		this.isChecked = paymentsEnabled;
	}

	successSetAccountQuickBook(): void {
		this.activeModal.close();
		this.messageService.showToaster('s_2', 'qb');
	}

	gatherData2Save(): object {
		const account = {
			taxCodeId: this.chosenTaxCodes.key,
			accountId: this.chosenAccount.key,
			paymentsEnabled: this.isChecked
		};
		return account;
	}

	changePathAfterIntegration(): void {
		window.history.replaceState(
			null,
			null,
			window.location.pathname.replace('/qb', '')
		);
	}

	saveQuickBooksSettings(): void {
		this.button_disabled = true;
		const data = this.gatherData2Save();
		const { accountId, taxCodeId } = this.accountList;
		const isSettingsToUpdate = !!(accountId || taxCodeId);

		this.integrationsDataService
			.saveQuickbooksSettings(isSettingsToUpdate, data)
			.pipe(
				finalize(() => {
					this.button_disabled = false;
					this.changePathAfterIntegration();
				}),
				takeUntil(this.unsubscribe)
			)
			.subscribe(
				() => this.successSetAccountQuickBook(),
				err => this.messageService.showDefaultErrorMessage(err)
			);
	}
	onDismiss(): void {
		this.activeModal.close();
		this.button_disabled = false;
		if (!this.accountList.accauntId) {
			this.changePathAfterIntegration();
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/integrations-section/modals/integrate-quick-books-modal/integrate-quick-books-modal.ts